import { render, staticRenderFns } from "./PagePaymentSuccess.vue?vue&type=template&id=d868137c&scoped=true&"
import script from "./PagePaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PagePaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentSuccess.vue?vue&type=style&index=0&id=d868137c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d868137c",
  null
  
)

export default component.exports